export default class Modals {
  constructor(modal) {
    this.$ = modal;
    this.wrapperID = this.$.getAttribute('id');
    this.wrapper = this.$;
    this.openButtons = Array.from(document.querySelectorAll('.js-modal-open[data-modal="' + this.wrapperID + '"]'));
    this.closeButtons = Array.from(this.wrapper.querySelectorAll('.js-modal-close'));
    this.focusableElements = Array.from(this.wrapper.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    this.hiddenClass = 'm-hidden';
    this.noScrollClass = 'm-noscroll';
    this.initialize();
    this.bind();
  }

  initialize() {
    if (!this.wrapper.classList.contains(this.hiddenClass)) {
      this.modalOpen();
    }
  }

  bind() {
    this.openButtons.forEach(openButton => {
      openButton.addEventListener('click', this.modalOpen.bind(this));
    })
    this.closeButtons.forEach(closeButton => {
      closeButton.addEventListener('click', this.modalClose.bind(this));
    })
    this.wrapper.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        // モーダル内最初の要素でShift+Tabが押された場合、最後の要素にフォーカスを移動
        if (e.shiftKey && document.activeElement === this.focusableElements[0]) {
          e.preventDefault();
          this.focusableElements[this.focusableElements.length - 1].focus();
        }
        // 最後のフォーカス要素でTabが押された場合、最初の要素にフォーカスを移動
        else if (!e.shiftKey && document.activeElement === this.focusableElements[this.focusableElements.length - 1]) {
          e.preventDefault();
          this.focusableElements[0].focus();
        }
      }
    })
  }

  modalOpen() {
    this.wrapper.hidden = false;
    this.wrapper.classList.remove(this.hiddenClass);
    this.bodyScrollStop();
    setTimeout(() => {
      this.wrapper.setAttribute("tabindex","");
      this.wrapper.focus();
    }, 500);
  }
  modalClose() {
    this.wrapper.scrollTo(0, 0);
    this.wrapper.classList.add(this.hiddenClass);
    this.wrapper.hidden = true;
    this.bodyScrollAuto();
  }

  bodyScrollStop() {
    document.body.style.top = `-${window.scrollY}px`;
    document.body.classList.add(this.noScrollClass);
    document.documentElement.style.scrollBehavior = 'auto';
  }
  bodyScrollAuto() {
    const top = document.body.style.top;
    document.body.classList.remove(this.noScrollClass);
    window.scrollTo(0, parseInt(top || '0') * -1);
    document.body.style.top = '';
    document.documentElement.style.scrollBehavior = 'smooth';
  }

}

